
import GoogleAnalytics from './Google';
import CustomAnalytics from './Custom';

import Content from '../Content';

import { add_to_local_storage_counter } from '../../helpers/utils';

const LogFileString = 'controllers::Analytics::Base';

const Analytics = {

  processConfiguration: (loadedConfiguration, contentData, auxiliarData) => {
    const LogFunctionString = `${LogFileString}::Analytics::processConfiguration`;
    const analyticsConfiguration = {
      referrer: document.referrer,
      platform: {
        id: loadedConfiguration?.platformId,
      },
      iframe: {
        id: loadedConfiguration?.id,
        name: loadedConfiguration?.name,
      },
      media: Content.getCurrentMediaInfo( contentData),
      google: GoogleAnalytics.processConfiguration( loadedConfiguration),
    };

    try {
      analyticsConfiguration.referrer = window.top.location.hostname;
    } catch( error) {
      console.warn( new Date(), `WARNING ${LogFunctionString} - error: `, error);
    }

    return analyticsConfiguration;
  },

  changeCurrentMedia: (analyticsConfiguration, contentData, current_playlist_index, current_element_duration) => {
    analyticsConfiguration.media = Content.getCurrentMediaInfo( contentData, current_playlist_index);
    analyticsConfiguration.media.duration = current_element_duration;
  },

  onLoad: (analyticsConfiguration) => {
    GoogleAnalytics.onLoad( analyticsConfiguration);
    CustomAnalytics.onLoad( analyticsConfiguration);
  },

  onPlay: (analyticsConfiguration) => {
    GoogleAnalytics.onPlay( analyticsConfiguration);
    CustomAnalytics.onPlay( analyticsConfiguration);
  },

  onTime: (analyticsConfiguration, time, duration) => {
    GoogleAnalytics.onTime( analyticsConfiguration, time, duration);
    CustomAnalytics.onTime( analyticsConfiguration);
  },

  onPause: (analyticsConfiguration) => {
    CustomAnalytics.onPause( analyticsConfiguration);
  },

  onBuffer: (analyticsConfiguration) => {
    CustomAnalytics.onBuffer( analyticsConfiguration);
  },

  onError: (analyticsConfiguration) => {
    CustomAnalytics.onError( analyticsConfiguration);
  },

  onAdImpresion: (analyticsConfiguration) => {
    CustomAnalytics.onAdImpresion( analyticsConfiguration);
  },

  onAdSkipped: (analyticsConfiguration) => {
    CustomAnalytics.onAdSkipped( analyticsConfiguration);
  },

  onAdClicked: (analyticsConfiguration) => {
    GoogleAnalytics.onAdClicked( analyticsConfiguration);
    CustomAnalytics.onAdClicked( analyticsConfiguration);
  },

  onAdError: (analyticsConfiguration) => {
    CustomAnalytics.onAdError( analyticsConfiguration);
  },

  onAdPlayed: (analyticsConfiguration) => {
    GoogleAnalytics.onAdPlayed( analyticsConfiguration);
    CustomAnalytics.onAdPlayed( analyticsConfiguration);
  },

  onUnload: (analyticsConfiguration) => {
    add_to_local_storage_counter('Analytics::onUnload');
    CustomAnalytics.onUnload( analyticsConfiguration);
  },

};

export default Analytics;
